import { Component, OnInit } from '@angular/core';
import {CommonUtil} from '../../../../utils/common.util';

@Component({
  selector: 'app-super-admin-footer',
  templateUrl: './super-admin-footer.component.html',
  styleUrls: ['./super-admin-footer.component.scss']
})
export class SuperAdminFooterComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();
  public SCHOOL_NAME = CommonUtil.getSchoolCopyright();

  constructor() { }

  ngOnInit() {
  }

}
